import {useEffect, useState} from "react";
import {
    useDeleteMyOrderMutation,
    useMyOrdersQuery,
    useOrdersHistoryQuery
} from "../services/react-query/useOrdersQuery";



const useCurrentOrders = () => {

    const initialState = {
        page: 1,
        dateFrom: null,
        search: {
            type: "type",
            submit: "submit",
            coin: 'coin'
        },
        query: {
            type: "",
            submit: "",
            coin: ''
        },
    }
    const [filterQueries, setFilterQueries] = useState(initialState)

    const {data: currentOrders, isFetching, refetch} = useMyOrdersQuery(filterQueries)
    const {mutate: deleteOrder} = useDeleteMyOrderMutation()


    const [deleteModal, setDeleteModal] = useState({id: null, open: false})
    const [allPages, setAllPages] = useState(null)


    useEffect(() => {
        refetch()
    }, [filterQueries, refetch])

    useEffect(() => {
        if ((currentOrders && !allPages) || (currentOrders && currentOrders.meta.total !== allPages)) {
            setAllPages(currentOrders.meta.total)
        }
        // eslint-disable-next-line
    }, [currentOrders]);


    const onModalClicked = (submit) => {
        if (submit) {
            deleteOrder(deleteModal.id)
        }
        setDeleteModal({id: null, open: false})
    }


    return {
        currentOrders, setDeleteModal,
        allPages, filterQueries,
        setFilterQueries, initialState,
        isFetching, onModalClicked,
        deleteModal
    }
}


const useOrdersHistory = () => {
    const initialState = {
        page: 1,
        dateFrom: null,
        search: {
            type: 'order.type',
            coin: 'order.coin'
        },
        query: {
            type: '',
            coin: ''
        },
    }
    const [filterQueries, setFilterQueries] = useState(initialState)

    const [allPages, setAllPages] = useState(null)
    const { data: orders, isFetching, refetch } = useOrdersHistoryQuery(filterQueries)

    useEffect(() => {
        if ((orders && !allPages) || (orders && orders.meta.total !== allPages)) {
            setAllPages(orders.meta.total)
        }
        // eslint-disable-next-line
    }, [orders])

    useEffect(() => {
        refetch()
    }, [filterQueries, refetch])

    return {
        orders, allPages,
        filterQueries, setFilterQueries,
        initialState, isFetching
    }
}

export {
    useCurrentOrders,
    useOrdersHistory
}